



































































import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  ref,
} from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';

import {
  getDashboard,
  getPurchaseRequests,
  getPurchaseRequestItems,
  getPurchaseOrderStats,
} from '@/api';
import dashboardOption from '@/table/PurchaseRequest/dashboard';

const PurchaseDashboard = defineComponent({
  setup(props) {
    const toDate = (date: string): string => useFormat.date(date).displayFullThaiDate();
    const toCurrency = (amount: number): string => (amount || 0).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 0 });

    const purchaseOrderItems = ref([]);
    const totalOverdueItems = ref(0);

    const purchaseOrderItemStatusCounter = reactive({
      PENDING: 0,
      WAITING: 0,
      OVERDUE: 0,
      FULFILLED: 0,
    });

    const computedPurchaseStatusChart = computed(() => ([
      { name: 'รายการรอสั่งซื้อ', data: purchaseOrderItemStatusCounter.PENDING, color: 'green' },
      { name: 'รอยืนยันได้รับสินค้า', data: purchaseOrderItemStatusCounter.WAITING, color: 'blue' },
      { name: 'เกินกำหนดจัดส่ง', data: purchaseOrderItemStatusCounter.OVERDUE, color: 'red' },
    ]));

    async function getDashboardData() {
      const { overduePoItems, totalOverduePoItems } = await getDashboard({
        materials: true,
        overduePoItems: true,
        overduePoItemsLimit: 10,
      });
      purchaseOrderItems.value = overduePoItems;
      totalOverdueItems.value = totalOverduePoItems;
    }
    const defaultFilter = {
      searchString: '',
      status: '',
      materials: [],
      date: undefined,
    };
    const filter = reactive(defaultFilter);
    async function getStats() {
      const { total } = (await getPurchaseRequests({ status: 'PENDING' })).data;
      const { waiting, overdueItem, fulfilledItem } = (await getPurchaseOrderStats({ date: filter.date }));
      purchaseOrderItemStatusCounter.WAITING = waiting || 0;
      purchaseOrderItemStatusCounter.PENDING = total || 0;
      purchaseOrderItemStatusCounter.OVERDUE = overdueItem || 0;
      purchaseOrderItemStatusCounter.FULFILLED = fulfilledItem || 0;
    }

    onMounted(async () => {
      await getStats();
      await getDashboardData();
    });

    return {
      toDate,
      toCurrency,
      dashboardOption,
      getPurchaseRequestItems,
      purchaseOrderItems,
      totalOverdueItems,

      computedPurchaseStatusChart,
      purchaseOrderItemStatusCounter,
    };
  },
});

export default PurchaseDashboard;
